var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHearthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 54,
    viewBox: "0 0 60 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6006 2.46094C26.642 0.712541 31.7143 1.78026 34.3926 4.99414L34.9668 5.68359L35.543 4.99609C37.3615 2.8278 40.5147 1.63392 43.3916 1.63379C44.9085 1.63379 45.551 1.7127 45.9688 1.83008C46.1721 1.88723 46.3395 1.95876 46.5596 2.06152C46.7739 2.16163 47.0473 2.29475 47.4082 2.44238V2.44336C48.8242 3.06808 49.9863 3.97347 50.8652 5.0752C52.4912 9.26121 51.9574 12.6168 51.0332 14.9268C50.5645 16.098 49.9922 17.0078 49.54 17.6211C49.3144 17.9272 49.1191 18.1586 48.9834 18.3105C48.9157 18.3863 48.8625 18.442 48.8281 18.4775C48.811 18.4953 48.7985 18.5082 48.791 18.5156L48.7842 18.5225L48.2324 19.0527L48.2822 19.1025C46.5538 20.9654 44.3565 22.9216 41.7178 24.8984L34.9492 29.4395C33.7558 28.7511 31.1173 27.1035 28.2734 24.917V24.916L28.2705 24.9141L27.3252 24.1826C22.6997 20.5388 19.554 17.0739 18.0752 14.0615C15.9471 9.72065 17.9316 4.49004 22.5996 2.45996L22.6006 2.46094Z",
    stroke: "#005FC8",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4595 40.0299L35.8721 43.8587L56.3945 31.8975C56.6396 31.7597 56.8999 31.6831 57.1909 31.6831C58.1864 31.6831 59.0594 32.3263 59.3044 33.2299L59.5188 34.011C59.7792 35.0218 59.381 36.0786 58.4927 36.7065L36.791 51.8686C36.1937 52.2974 35.5045 52.6037 34.7694 52.8028L33.7433 53.0632C33.0541 53.247 32.3189 53.2317 31.6451 53.0173L10.1425 46.3092C9.16228 46.0029 8.09021 46.0794 7.17129 46.5083L0.310059 49.6938",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04102 36.4156L15.8554 31.9895C16.4374 31.8057 17.05 31.7445 17.6626 31.8211L41.3859 34.6544C42.458 34.7769 43.2237 35.6805 43.1319 36.6913L43.0246 37.9012C42.9174 38.9886 41.9679 39.8309 40.8039 39.8463L28.4598 40.0454L23.4824 39.8769",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4058 34.5164L49.6255 31.0704C50.1156 30.902 50.667 30.902 51.1571 31.0704C52.2904 31.438 53.0408 32.4488 53.0408 33.5821V33.8578",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3191 19.0787C47.4812 21.1462 45.0768 23.321 42.1515 25.5111L34.984 30.3201C34.0498 29.8147 31.0633 28.0075 27.8165 25.5111C22.6399 21.5751 19.0561 17.7616 17.4021 14.3922C15.0742 9.64448 17.2642 3.96252 22.303 1.77243C26.6219 -0.0960272 32.0588 1.02199 34.9687 4.51387C36.9597 2.14 40.3443 0.884149 43.3921 0.884149C46.4398 0.884149 46.3173 1.19045 47.711 1.75712C49.2731 2.44631 50.5596 3.45711 51.5245 4.69765",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7847 8.52588V11.8188H55.2769V12.7847H51.7847V16.0776H50.6665V12.7847H47.1743V11.8188H50.6665V8.52588H51.7847Z",
    fill: "#A3C5EB",
    stroke: "#005FC8",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearthIcon);
export default __webpack_public_path__ + "static/media/hearth-icon.eb7ae7fc.svg";
export { ForwardRef as ReactComponent };